/**
 * 首页 15 个 H2 长文（PDF 要求）+ 结构化段落（支持内链）
 */

/** @typedef {{ text?: string, link?: { to: string, text: string } }} ContentPart */
/** @typedef {{ parts: ContentPart[] }} ParagraphBlock */

/** @param {ContentPart[]} parts */
function p(parts) {
	return { parts };
}

export const HOME_SECTIONS = [
	{
		id: 'what-is-gb-whatsapp',
		h2: 'What is GB WhatsApp?',
		layout: 'what-is-intro',
		figure: {
			srcKey: 'whatIsBanner',
			alt: 'What is GB WhatsApp — GBWaps guide banner for Android mod features',
		},
		introParts: [
			{
				text: 'GB WhatsApp is a modified version of the original WhatsApp application created to give you greater control, ',
			},
			{ text: 'improved privacy settings', strong: true },
			{ text: ', ' },
			{ text: 'advanced customization options', strong: true },
			{ text: ', and ' },
			{ text: 'improved media sharing', strong: true },
			{
				text: ' that the official app does not offer. The GB WhatsApp app keeps the same chat list, calls, and voice notes—you install an enhanced version on Android instead of using Google Play.',
			},
		],
		blocks: [
			p([
				{
					text: 'Unlike stock WhatsApp, this mod version removes several limits: advanced theme customization, extended privacy controls, and tools such as anti-delete messages or status download on supported builds. GBWhatsApp still looks familiar, so you are not learning a brand-new app from scratch.',
				},
			]),
			p([
				{
					text: 'Independent developers ship GB WhatsApp as an APK, not through the Play Store. Meta does not endorse unofficial clients—use it for extra flexibility at your own risk. GBWaps lists file size, version 18.80, and install steps below so you know what you are sideloading.',
				},
			]),
		],
	},
	{
		id: 'latest-version-2026',
		h2: 'GB WhatsApp Latest Version Overview 2026',
		badge: 'v18.80',
		figure: { srcKey: 'featureOverview', alt: 'GB WhatsApp latest version 2026 interface overview', caption: 'Current GB WhatsApp build overview on Android.' },
		blocks: [
			p([
				{
					text: 'The GB WhatsApp latest version we track is v18.80, about 82 MB, for Android 4.4 and up. May 2026 builds focus on smoother login, anti-ban tweaks, and Android 14 compatibility. Always match the number on this page with the APK you install—whatsapp GB mirrors with wrong version tags often cause “temporarily banned” or endless verifying.',
				},
			]),
			p([
				{
					text: 'After install, open Settings → GB Settings (or About) and confirm 18.80. Typical changelog items include anti-delete message support, faster theme store loading, and crash fixes on Samsung and Xiaomi phones. If About shows an older tag, delete the partial file and grab a fresh GB WhatsApp download from GBWaps.',
				},
			]),
			p([
				{
					text: 'Upgrading without drama? Open the update guide from the site menu—back up chats first, then install over the old APK without uninstalling.',
				},
			]),
		],
	},
	{
		id: 'why-people-use',
		h2: 'Why People Use GB WhatsApp',
		badge: 'Real reasons',
		blocks: [
			p([
				{
					text: 'Most people install GBWhatsApp for privacy and look. You can read messages without sending blue ticks, freeze last seen, and hide typing or recording indicators. Power users also want bigger uploads, custom fonts, and chat bubbles that make long groups readable—features the official app keeps locked down.',
				},
			]),
			p([
				{
					text: 'Small shops sometimes run a GB WhatsApp pro style setup: one mod number for customers, official WhatsApp for family, plus chat locks and custom notification icons. Creators save status videos with built-in download tools. Students schedule birthday texts. None of this requires shady plugins—just toggles inside the mod.',
				},
			]),
			p([
				{
					text: 'Trade-off: no Meta support desk and higher ban risk than stock WhatsApp. Read the anti-ban section before you move your main SIM to a mod.',
				},
			]),
		],
	},
	{
		id: 'key-features',
		h2: 'Key Features of GB WhatsApp',
		badge: '6 highlights',
		layout: 'feature-grid',
		blocks: [
			p([
				{
					text: 'Below is what most v18.80 GB WhatsApp APK builds include. Names and menu paths vary by developer—open Privacy and Themes after install to see your exact toggles.',
				},
			]),
			p([
				{ text: 'Want screenshots and toggle paths? See the full ' },
				{ link: { to: '/features/', text: 'GB WhatsApp Features' } },
				{ text: ' list on GBWaps.' },
			]),
		],
	},
	{
		id: 'privacy-security',
		h2: 'Privacy & Security Features',
		badge: 'Know the limits',
		blocks: [
			p([
				{
					text: 'Privacy mode usually bundles hide double tick, hide blue tick, hide second tick, and hide “forwarded” labels. You can keep deleted messages visible on your phone, blur contact photos, or lock the whole GB WhatsApp app with a PIN or fingerprint on supported builds.',
				},
			]),
			p([
				{
					text: 'Security is separate from privacy. Most GB WhatsApp APK files are not open source—you trust the packager. Download only when the page lists version and size clearly. Skip clones that demand SMS or device-admin access without a clear reason. Keep Android security patches current; a mod cannot fix an outdated OS.',
				},
			]),
			p([
				{
					text: 'For banking or work secrets, official WhatsApp or Signal is still safer. Use the enhanced version for everyday chats and customization, not classified data—especially after Meta enforcement waves.',
				},
			]),
		],
	},
	{
		id: 'how-to-download',
		h2: 'How to Download GB WhatsApp APK',
		badge: 'Quick path',
		blocks: [
			p([
				{
					text: 'Use the download showcase above on your phone (or desktop, then USB the file). Tap the green button, wait for ~82 MB, and note the filename. Chrome may warn about unknown files—that is normal for mods if the host is gbwaps.com.',
				},
			]),
			p([
				{
					text: 'Never install from random blog pop-ups labeled “GB WhatsApp plus.” Compare version 18.80 and 82 MB; mismatches mean a repack. Run Play Protect or your antivirus if you want—false positives happen, but wrong size should stop you cold.',
				},
			]),
		],
	},
	{
		id: 'download-requirements',
		h2: 'Download Requirements for GB WhatsApp',
		badge: 'Checklist',
		layout: 'requirement-cards',
		blocks: [
			p([
				{
					text: 'Before you grab the GB WhatsApp APK, confirm these four areas—most failed installs trace back to storage, wrong architecture, or blocked unknown-app permission.',
				},
			]),
		],
	},
	{
		id: 'how-to-install',
		h2: 'How to Install GB WhatsApp on Android',
		badge: 'Step-by-step',
		layout: 'install-steps',
		blocks: [
			p([
				{
					text: 'After the GB WhatsApp download finishes, tap the APK. Allow unknown apps once, confirm installer shows 18.80, then tap Install. First launch asks for country code and SMS code—same flow as official WhatsApp.',
				},
			]),
			p([
				{ text: 'Stuck on errors? Open ' },
				{ link: { to: '/install-gbwhatsapp/', text: 'How to Install GB WhatsApp APK' } },
				{ text: ' for MIUI, split APK, and storage fixes with screenshots.' },
			]),
			p([
				{
					text: 'Do not install below 15% battery. Keep the screen on until verification completes so the process does not corrupt mid-way.',
				},
			]),
		],
	},
	{
		id: 'how-to-update',
		h2: 'How to Update GB WhatsApp Safely',
		badge: 'Keep chats',
		blocks: [
			p([
				{
					text: 'Updates never come from Play Store. When GBWaps posts 18.80, download the new GB WhatsApp APK and install over the old one—Android upgrades in place when signatures match. Back up in Settings → Chats → Chat backup before big jumps.',
				},
			]),
			p([
				{
					text: 'If the app says “This version is outdated,” update soon—stale clients trigger bans. Clear cache only when our update guide says so; blind wipes cause login loops on Android 14.',
				},
			]),
			p([
				{
					text: 'Uninstall only when switching developers or leaving mods for good—otherwise you risk losing local DB files. The site update guide has cache and login-loop fixes.',
				},
			]),
		],
	},
	{
		id: 'is-it-safe',
		h2: 'Is GB WhatsApp Safe to Use?',
		badge: 'Honest take',
		blocks: [
			p([
				{
					text: '“Safe” depends on your threat model. For hiding ticks and themes, many users run the unofficial app daily. For regulated work, stay on official WhatsApp. GBWhatsApp is not verified by Meta; shady repacks can add ads or trackers—stick to sources that publish file metadata.',
				},
			]),
			p([
				{
					text: 'Account risk is real: Meta may restrict numbers on unsupported clients. Update quickly, avoid mass forwards, and do not route banking OTPs through a mod. Patch your phone OS; a mod cannot fix kernel holes.',
				},
			]),
			p([
				{
					text: 'Check live fixes on the troubleshooting hub before you sideload on a brand-new flagship.',
				},
			]),
		],
	},
	{
		id: 'anti-ban',
		h2: 'Anti-Ban Protection Explained',
		badge: 'Reduce risk',
		blocks: [
			p([
				{
					text: 'Anti-ban means developer server tweaks plus calm usage. v18.80 builds often advertise anti-ban—treat it as lower risk, not a guarantee. Meta still flags spam patterns, old clients, and aggressive privacy flips right after login.',
				},
			]),
			p([
				{ text: 'Warm up the account: normal chats for 48 hours, no blast forwarding, then enable hide online. See the ' },
				{ link: { to: '/anti-ban/', text: 'GB WhatsApp Anti Ban Guide' } },
				{ text: ' for the full checklist.' },
			]),
			p([
				{
					text: 'Got “temporarily banned”? Wait out the timer, install the newest APK once, restore backup—do not hop between five mods in one hour.',
				},
			]),
		],
	},
	{
		id: 'common-issues',
		h2: 'Common Issues & Fixes',
		badge: 'Fast fixes',
		blocks: [
			p([
				{
					text: 'Stuck on verifying? Sync date/time, switch Wi‑Fi, or grab the newest 18.80 package. Crash on open? Clear cache, free RAM, whitelist GBWhatsApp from battery killers. Messages stuck? Check ban status and background data permission.',
				},
			]),
			p([
				{ text: 'Restore failures often mean mixed 32/64-bit builds or skipping backups. Use ' },
				{ link: { to: '/troubleshooting/', text: 'GB WhatsApp Troubleshooting' } },
				{ text: ' for ordered fixes before a factory reset.' },
			]),
			p([
				{ text: 'Ban questions? Read ' },
				{ link: { to: '/blog/', text: 'Blog' } },
				{ text: ' posts on 2026 ban patterns and recovery habits.' },
			]),
		],
	},
	{
		id: 'comparison',
		h2: 'GB WhatsApp vs Official WhatsApp Comparison',
		badge: 'Side by side',
		layout: 'comparison',
		blocks: [
			p([
				{
					text: 'Official WhatsApp wins on policy, Play Store updates, and predictable security patches. GB WhatsApp wins on customization, privacy toggles, and media limits. Use the table to decide which app gets your main SIM.',
				},
			]),
		],
	},
	{
		id: 'faq-section',
		h2: 'FAQ Section',
		badge: 'Top questions',
		layout: 'faq',
		blocks: [
			p([
				{ text: 'Short answers below. For 50+ grouped questions, open the ' },
				{ link: { to: '/faq/', text: 'FAQ' } },
				{ text: ' hub.' },
			]),
		],
	},
	{
		id: 'final-summary',
		h2: 'Final Summary & Recommendation',
		badge: 'Bottom line',
		blocks: [
			p([
				{
					text: 'GB WhatsApp is the enhanced version for users who want control: themes, privacy, bigger files, and status tools on one Android phone. It is not official— you manage updates, APK trust, and ban risk yourself.',
				},
			]),
			p([
				{
					text: 'Our recommendation: download only from GBWaps, match v18.80 / 82 MB, back up before every update, and read anti-ban plus troubleshooting guides before you move a primary number.',
				},
			]),
			p([
				{
					text: 'Ready? Use the green download button on this page, or jump to the features list if you still compare options.',
				},
			]),
		],
	},
];

export const INTRO_LEAD = {
	parts: [
		{ link: { to: '/', text: 'GB WhatsApp' } },
		{
			text: ' is a practical mod for Android: same chats and calls, plus themes, privacy toggles, and larger media. The GB WhatsApp app is unofficial—you install a GB WhatsApp APK and handle updates yourself.',
		},
	],
};

/** PDF 要求：以下锚文本在首页各出现一次 */
export const HOME_SINGLE_LINKS = {
	install: { to: '/install-gbwhatsapp/', text: 'How to Install GB WhatsApp APK' },
	download: { to: '/download/', text: 'Download GB WhatsApp APK' },
	features: { to: '/features/', text: 'GB WhatsApp Features' },
	antiBan: { to: '/anti-ban/', text: 'GB WhatsApp Anti Ban Guide' },
	faq: { to: '/faq/', text: 'FAQ' },
	troubleshooting: { to: '/troubleshooting/', text: 'GB WhatsApp Troubleshooting' },
	oldVersion: { to: '/old-version/', text: 'GB WhatsApp Old Version' },
	blog: { to: '/blog/', text: 'Blog' },
};
